import Basic from './basic.vue';

export const componentMap = {
	basic: Basic
};
